import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
    BoxContainer,
    BoxTitle,
    BoxHead,
    Underline,
    FilterTableWrapper,
    FilterWrapper,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import SearchFilterBox from "../../Components/SearchFilterBox";
import { toast } from "react-toastify";
import Table from "../../Components/LandlordPortal/Properties/Table";
import SideModal from "../../Components/SideModal";
import ViewDetails from "../../Components/LandlordPortal/Properties/ViewDetails";

const LandlordPropertyList = () => {
    const searchOptions = [
        { label: "Name", value: 1 },
    ];

    const user = useSelector((state) => state.UserReducer.user);
    const [selectedData, setSelectedData] = useState("");
    const [apiData, setApiData] = useState([]);
    const [showViewDetails, setShowViewDetails] = useState(false);
    const [filterType, setFilterType] = useState("");
    const [searchQuery, setSearchQuery] = useState("");

    const fetchFunction = async (params) => {
        const query = `&s=${params.searchQuery || ""}&t=${params.filterType || ""}`;
        const response = await axios.get(
            `${Config.apiUrl}/landlord/list/properties?${query}`,
            {
                headers: {
                    authorization: `Bearer ${user.token}`,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );
        return response.data;
    };

    const getSuccess = (res) => {
        if (res.isSuccess) {
            setApiData(res.list);
        }
    };

    const getError = (err) => {
        toast.error(err?.response?.data?.msg || "An Error Occurred");
    };

    const {
        isLoading,
        mutate: getListMutate,
        error,
        isRefetching,
        data,
    } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
        onError: getError,
    });

    useEffect(() => {
        getListMutate({ searchQuery, filterType });
    }, [searchQuery, filterType, getListMutate]);

    const handleFilterChange = (values) => {
        sessionStorage.removeItem("landlord_list_page");
        setFilterType(values.filterType);
        setSearchQuery(values.searchQuery);
    };

    const handleClearFilters = () => {
        setFilterType("");
        setSearchQuery("");
    };

    const onClose = () => {
        setShowViewDetails(false);
    };
    return (

        <BoxContainer>
            <BoxHead>
                <BoxTitle className="!mb-0 whitespace-nowrap">
                    Properties
                    <Underline />
                </BoxTitle>
            </BoxHead>
            <SideModal
                isOpen={showViewDetails}
                onClose={onClose}
            >
                <ViewDetails
                    selectedData={selectedData}
                    onClose={onClose}
                />
            </SideModal>
            <FilterTableWrapper>
                <FilterWrapper>
                    <div className="flex md:space-x-4 md:flex-row flex-col md:gap-0 gap-4">
                        <SearchFilterBox
                            options={searchOptions}
                            handleFilterChange={handleFilterChange}
                            handleClearFilters={handleClearFilters}
                        />
                    </div>
                </FilterWrapper>

                {!error && !isLoading && data && (
                    <TableWrapper>
                        <Table
                            apiData={apiData || []}
                            setSelectedData={setSelectedData}
                            selectedData={selectedData}
                            setShowViewDetails={setShowViewDetails}
                        />
                        {(!apiData || apiData.length === 0) && <NotFoundModel />}
                    </TableWrapper>
                )}
            </FilterTableWrapper>

            {error && !isLoading && <NotFoundModel />}
            {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
    );
};

const TableWrapper = tw.div`mt-4 bg-white rounded-md`;

export default LandlordPropertyList;
